import * as React from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Input, Label, Row } from 'reactstrap';
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import {
    Afr, DimensionReference, FactTable, generateAffiliateNoDataState, generateLocalStateFromEventProperties,
    getSelectedAfr, getTable, updateAffiliateNoData, updateVersionStateValue
} from '../../redux/AfrSlice';
import { Concept, loadConcept } from '../../redux/ConceptSlice';
import { getSectionDimensionMap, setIsDirty } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { ErrorGrid, updateSupplementalGridErrors } from '../../redux/ValidationSlice';
import dateHelper from '../../utils/dateHelper';
import enums from '../../utils/enums';
import utilityHelper from '../../utils/utilityHelper';
import { ShowSupplementalGridErrorList } from './ShowSupplementalGridErrorList';
import { AdminUserRoleEnum, selectAdminUserRole } from '../../redux/UserSlice';


const RowDimensionNoDataCheckBox = (props: {
    componentTitle: string;
    tableName: string,
    affiliateCode: string,
    noDataState: string,
    gridId: string,
    taxonomyType: TaxonomyTypeEnum
    hasFacts: boolean
    noData: any,
    updateNoData: (newState: any) => void;
}) => {
    /* ************************************** Redux ********************************************/
    const dispatch = useAppDispatch();
    /* ************************************** Modal section ************************************/



    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const [checkBoxState, setCheckboxState] = useState(false);
    const [state, setState] = useState(props.noData) //useState(props.affiliateCode ? generateAffiliateNoDataState(currentAfr, props.affiliateCode, props.noDataState) : generateLocalStateFromEventProperties(currentAfr, [props.noDataState]));
    let title: string = props.componentTitle;
    const adminUserRole: AdminUserRoleEnum | null = useAppSelector(selectAdminUserRole);

    /* ***********************************************************************************************************/
    //Events
    /* ***********************************************************************************************************/

    const isNoData = function (): boolean {
        var currentState = props.noData; //props.affiliateCode ? generateAffiliateNoDataState(currentAfr, props.affiliateCode, props.noDataState) : generateLocalStateFromEventProperties(currentAfr, [props.noDataState]);
        if (!currentState) {
            return false;
        }
        return currentState[props.noDataState] === true;
    }

    const handleChangeCheckbox = function (event: any) {

        var value: boolean = event.target.checked;
        var key = props.noDataState;
        var newState: any = { ...props.noData };
        newState[key] = value;

        setState(newState);
        // call to dispatcher by sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        if (props.affiliateCode) {
            dispatch(updateAffiliateNoData({ affiliate: props.affiliateCode, propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value }));
        } else {
            dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));
        }
        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }))

        /* This part should be replaced it by a call to redux to save this state into Misc or AFR instead of a local state.  
           Performing this approach avoids that the grid constantly is refreshed when the check box is clicked */
        setCheckboxState(value);
        props.updateNoData(newState);

    }


    // ************************************************************* /*
    // General purpose functions                                     //
    // ************************************************************* /*
    function noDataDisabled(noData: boolean) {
        if (props.hasFacts) {
            if (noData === false) {
                return true;
            }
        }
        return utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified);
    }


    return (
        <>
            <Row>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <Col md="12">
                    <Row>
                        <Col>
                            <Row>
                                {props.noDataState.length > 0
                                    ?
                                    <Col md="6">
                                        <Row style={{ marginLeft: "0.25em", marginBottom: "1em" }}>
                                            <Label className="ml-4" check>
                                                <Input type="checkbox"
                                                    name="noRows"
                                                    onChange={handleChangeCheckbox}
                                                    disabled={noDataDisabled(state[props.noDataState])
                                                        || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                    checked={state[props.noDataState] ? true : false}
                                                />{' '} <b>No {title}</b>
                                            </Label>
                                        </Row>
                                    </Col>
                                    :
                                    <div>hello</div>

                                }
                            </Row>
                        </Col>
                    </Row>

                </Col>
            </Row>


        </>


    );
}


export { RowDimensionNoDataCheckBox };


